var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.5C2.5 1.22386 2.72386 1 3 1H8C8.27614 1 8.5 1.22386 8.5 1.5V5.5C8.5 5.77614 8.27614 6 8 6H3C2.72386 6 2.5 5.77614 2.5 5.5V1.5ZM3.5 2V5H7.5V2H3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.5H6V7.75H11V8.75H6V13H11V14H5V5.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 12C10.5 11.7239 10.7239 11.5 11 11.5H13.5C13.7761 11.5 14 11.7239 14 12V14.5C14 14.7761 13.7761 15 13.5 15H11C10.7239 15 10.5 14.7761 10.5 14.5V12ZM11.5 12.5V14H13V12.5H11.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7C10.5 6.72386 10.7239 6.5 11 6.5H13.5C13.7761 6.5 14 6.72386 14 7V9.5C14 9.77614 13.7761 10 13.5 10H11C10.7239 10 10.5 9.77614 10.5 9.5V7ZM11.5 7.5V9H13V7.5H11.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4C5 4.27614 4.77614 4.5 4.5 4.5C4.22386 4.5 4 4.27614 4 4C4 3.72386 4.22386 3.5 4.5 3.5C4.77614 3.5 5 3.72386 5 4Z",
    fill: "#283897"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTree);
export default __webpack_public_path__ + "static/media/FileTree.b06adae1.svg";
export { ForwardRef as ReactComponent };